import { useEffect } from 'react'

export function InitialImageReplacer() {
  // hydration が終わると useEffect が実行されて MutationObserver を停止する
  useEffect(() => {
    // @ts-ignore
    const observer = globalThis.initialImageObserver
    if (observer) {
      observer.disconnect()
      // @ts-ignore
      delete globalThis.initialImageObserver
    }
  }, [])

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `(function() {
          function replace(img) {
            const fullSrc = img.dataset.fullSrc;
            if (!fullSrc) {
              return;
            }
            if (img.src === fullSrc) {
              return;
            }
            const full = new Image();
            full.src = fullSrc;
            full.onload = function() {
              img.src = fullSrc;
            }
          }
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mr) => {
              if (mr.type === 'childList') {
                mr.addedNodes.forEach((node) => {
                  if (node.nodeType === 1 && node.tagName === 'IMG') {
                    replace(node);
                  }
                })
              }
            })
          });
          observer.observe(document.querySelector('body'), {
            childList: true,
            attributes: false,
            characterData: false,
            subtree: true,
          });
          globalThis.initialImageObserver = observer;
        })();`,
      }}
    />
  )
}
